import { Viewer } from '../Viewer';
import * as THREE from 'three';
import { ViewerScene } from '../ViewerScene';
import { PointerButtons } from '../Events/ViewerEvents';
import { ArrowHelper } from 'three';
import { Bitflag } from '../Helpers/Bitflag';
import { EventEmitter } from 'events';

export abstract class ViewerTool {
    protected Tool!: string;
    public get ToolName(): string {
        return this.Tool;
    }

    protected _viewer: Viewer;
    protected _toolEvent: EventEmitter | null = null;
    protected _cursor!: ArrowHelper;
    protected _pointerState: Bitflag<PointerButtons> = new Bitflag();
    constructor(viewer: Viewer) {
        this._viewer = viewer;
        if (!viewer.ViewerEvents) {
            throw new Error('Viewerevents is a requirement for any tool! Did you forget to instantiate the viewer events?');
        }
        this._toolEvent = viewer.ViewerEvents.ToolEvents;
    }
    abstract SetScene(scene: ViewerScene): void;
    /**
     * Method for when pointer is first pressed
     * @param coords
     * @param button
     * @param buttons
     */
    OnPointerDown(coords: THREE.Vector2, button: string, buttons: PointerButtons, e?: any): void {
        this._pointerState.addFlag(buttons);
        switch (button) {
            case 'PRIMARY': {
                this.onPrimaryDown(coords, e);
                break;
            }
            case 'SECONDARY': {
                this.onSecondaryDown(coords, e);
                break;
            }
        }
    }
    /**
     * Method is called when tool is activated
     */
    Activate(viewer: Viewer) {
        this._viewer = viewer;
        this._toolEvent = viewer.ViewerEvents!.ToolEvents;
    }
    /**
     * Method is called when tool is deactivated
     */
    Deactivate() {
        this._toolEvent = null;
    }

    /**
     * Method for when pointer is released
     * @param coords
     * @param button
     * @param buttons
     */
    OnPointerUp(coords: THREE.Vector2, button: string, buttons: PointerButtons, e?: any): void {
        this._pointerState.removeFlag(buttons);
        switch (button) {
            case 'PRIMARY': {
                this.OnPrimaryUp(coords, e);
                break;
            }
            case 'SECONDARY': {
                this.OnSecondaryUp(coords, e);
                break;
            }
        }
    }
    /**
     * Method when pointer moves
     * @param coords
     * @param type
     * @param buttons
     */
    abstract OnPointerMove(coords: THREE.Vector2, type: string, buttons: PointerButtons, e?: any): void;
    /**
     * Method when the primary pointer button is pressed.
     * @param coords
     */
    onPrimaryDown(coords: THREE.Vector2, e?: any): void {}
    /**
     * Method for when the secondary pointer button is pressed
     * @param coords
     */

    OnDoubleClick(coords: THREE.Vector2, button: string, buttons: PointerButtons, e?: any) {}
    /**
     * Method for when there is a double click
     * @param coords
     */
    onSecondaryDown(coords: THREE.Vector2, e?: any) {}
    /**
     * Method when the primary pointer button is released.
     * @param coords
     */
    OnPrimaryUp(coords: THREE.Vector2, e?: any) {}
    /**
     * Method when the secondary pointer button is released.
     * @param coords
     */
    OnSecondaryUp(coords: THREE.Vector2, e?: any) {}

    /**
     * Method when a key is first held down (state 0->1)
     * @param keycode The keycode of the pressed key.
     */
    OnKeyPressed(keycode: string, e?: any): void {}
    /**
     * Method when a key is first released (state 1->0)
     * @param keycode
     */
    OnKeyReleased(keycode: string, e?: any): void {}
    /**
     * Method when a keys is held down (state == 1)
     * @param keycode
     */
    OnKeyDown(keycode: string, e?: any): void {}

    abstract cleanUp();
}
